module.exports = __webpack_public_path__ + "static/media/visa_2.d284dd51.svg";